import { render, staticRenderFns } from "./RiskDevice.vue?vue&type=template&id=00c0853f"
import script from "./RiskDevice.vue?vue&type=script&lang=js"
export * from "./RiskDevice.vue?vue&type=script&lang=js"
import style0 from "./RiskDevice.vue?vue&type=style&index=0&id=00c0853f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c0853f')) {
      api.createRecord('00c0853f', component.options)
    } else {
      api.reload('00c0853f', component.options)
    }
    module.hot.accept("./RiskDevice.vue?vue&type=template&id=00c0853f", function () {
      api.rerender('00c0853f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RiskDevice.vue"
export default component.exports